<template>
  <div>

    <div :style="{'position':'relative','background':'url(static/friend_link_bg.png) no-repeat','background-size':'auto 100%','background-position':'0px 0px','width':'100%','overflow':'hidden','height':'456px'}">
      <!--底部友情链接 start-->

      <div style="overflow:hidden;">
        <img src="static/logo1.png" style=" width:150px;margin-left:10px;margin-top:20px;float:left;" />
        
      </div>
      <div style="width:100px;left:150px;top:30px;color:#fff;float:left;margin-top:25px;margin-left:20px;font-size: 13px;">相关支持单位</div>
      <div style="width:100%;height:2px;border-bottom: 1px solid #72941e;margin-top:20px;"></div>

      <ul class="friend_link_ul">
        <li>
          <a href="http://see.org.cn" target="_blank">阿拉善SEE <br /> http://see.org.cn</a>

        </li>

        <li>
          <a href="http://www.cura.com.cn/" target="_blank">全联城基会中城分会 <br /> http://www.cura.com.cn/</a>

        </li>

        <li>
          <a href="http://www.chinahouse.info" target="_blank">全联房地产商会 <br /> http://www.chinahouse.info</a>

        </li>

        <li>
          <a href="http://www.wanke.com" target="_blank">万科集团 <br /> http://www.wanke.com</a>

        </li>
        <li>
          <a href="http://www.landsea.com" target="_blank">朗诗控股集团 <br /> http://www.landsea.com</a>

        </li>

        <li>
          <a href="http://www.mepfeco.org.cn" target="_blank">生态环境部对外合作与交流中心 <br /> http://www.mepfeco.org.cn</a>

        </li>

        <li>
          <a href="http://www.cabee.org" target="_blank">中国建筑节能协会 <br /> http://www.cabee.org</a>

        </li>
        <li>
          <a href="http://www.fangchan.com" target="_blank">中国房地产业协会 <br />http://www.fangchan.com</a>

        </li>
        <li>
          <a href="www.ipe.org.cn" target="_blank">公众环境研究中心（IPE） <br /> http://www.ipe.org.cn</a>

        </li>
        <li>
          <a href="http://www.bnbm.com.cn" target="_blank">北新建材 <br /> http://www.bnbm.com.cn</a>

        </li>
        <li>
          <a href="http://www.elitef.org.cn" target="_blank">精瑞人居发展基金会 <br /> http://www.elitef.org.cn</a>

        </li>
        <li>
          <a href="http://www.iGREEN.org" target="_blank">友绿 <br /> http://www.iGREEN.org</a>

        </li>
      </ul>

      <!--底部友情链接 end -->
    </div>

    <div :style="{'color':'#ffffff','position':'relative','background':'url(static/footer_bg.png) no-repeat','background-size':'auto 100%','background-position':'0px 0px','width':'100%','overflow':'hidden','height':'240px'}">
      <!--底部 start-->
      <ul class="footer_box">
        <li><a href="">走进GSC</a></li>
        <li><a href="">新闻中心</a></li>
        <li><a href="">招贤纳土</a></li>
        <li><a href="">联系我们</a></li>
        <li><a href="">内部用户登录</a></li>
      </ul>
      <span style="font-size: 13px;">Copyright 2015 GSC . all rights reserved京ICP备06008888号-1版权所有: GSC</span>
      <br /><br />
      <a href="http://www.acosoft.cn" style="color:#fff; text-decoration:none;font-size: 13px;">技术支持:恩创信息</a>

      <!--底部 end -->
    </div>

  </div>

</template>
<script>
import Vue from 'vue'
export default {
  name: 'index',
  data() {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.friend_link_ul {
  position: absolute;
  width: 100%;
  left: 10px;
  top: 80px;
  color: #fff;
  margin-top: 10px;
  padding: 0px;
}
.friend_link_ul li {
  margin: 0;
  padding: 0;
  float: left;
  width: 45%;
  margin-right: 2%;
  /* text-decoration: left; */
  text-align: left;
  font-size: 16px;
  margin-top: 20px;
  list-style: none;
  /* overflow: hidden; */
}
.friend_link_ul a {
  color: #fff;
  text-decoration: none;
  margin-top: 10px;
  text-align: left;
  word-break: break-all;
  font-size: 12px;
  /* display: block; */
}

.footer_box {
  color: #fff;
  overflow: hidden;
}
.footer_box li {
  margin: 0;
  padding: 0;
  float: left;
  width: 30%;
  margin-right: 1.5%;
  margin-left: 1.5%;
  text-decoration: left;
  margin-top: 20px;
  overflow: hidden;
  text-align: center;
}

.footer_box li a {
  color: #fff;
  text-decoration: none;
  text-align: center;
  display: block;
}
</style>


// WEBPACK FOOTER //
// src/components/friendLinkAndFooter.vue